import type { SetActivitySummaryTabAction } from './typings'

export const setActivitySummaryTabActionCreator = (
  payload: SetActivitySummaryTabAction['payload'],
): SetActivitySummaryTabAction => ({
  type: 'activitySummary/setTab',
  payload,
})
